import http from "./http";
import CircleService from "./circle";

export default class ProfileService {
  validate(obj) {
    if (
      obj.code === 200 &&
      obj.data !== null &&
      obj.data !== {} &&
      obj.data !== [] &&
      obj.data.length !== 0 &&
      Object.keys(obj.data).length !== 0
    ) {
      return true;
    }
    return false;
  }

  fetchUserProfile(user_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("_id", user_id);
      http
        .post("profile/read", form)
        .then(body => {
          body = body["data"];
          if (body["code"] === 200) {
            resolve(body["data"][0]);
          } else {
            reject(body);
          }
        }).catch((err) => reject(err));
    });
  }

  getSuggestedProfile(meta) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("meta", meta || '');
      http
        .post("profile/suggest", form)
        .then(body => {
          body = body["data"];
          if (body["status"] === "active") {
            resolve(body)
          } else {
            reject(body);
          }
        }).catch(err => reject(err));
    })
  }
}
